












































import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import { AccessRoleTypes, UUID } from "@/data/enums";
import UserProvider from "@/components/app/admin/users/userProvider.vue";
import UserWell from "@/components/app/admin/users/userWellLink.vue";
import ClientProvider from "@/components/app/global/client/clientProvider.vue";
import ClientWellLink from "@/components/app/admin/clients/clientWellLink.vue";
import CProdProvider from "@/components/app/global/contractProducts/cProdProvider.vue";
import CProdWellLink from "@/components/app/global/contractProducts/cProdWellLink.vue";
import { IHookLog } from "@/models/hooks";
import { ProductCategoryTypes } from "@/data/enums/products";
import { IClientProviderData } from "@/models/providers/client";

@Component
export default class TimelineLogModal extends Vue {
  @Prop({ required: true })
  public data!: IHookLog;

  // Getters
  public get actorLink() {
    const arr = [`${this.data.actor?.fullname}`, `(${this.data.actor?.email})`];
    if (this.data.access_user_id === UUID.SYS)
      return {
        render: (h: CreateElement) =>
          h("span", {}, this.$t("_.system") as string)
      };
    if (this.data.access_role === AccessRoleTypes.USER)
      return {
        render: (h: CreateElement) =>
          h(
            "u-link",
            {
              props: {
                tag: "router-link"
              },
              attrs: {
                to: {
                  name: "adminUser",
                  params: { userId: this.data.access_user_id }
                }
              }
            },
            [[`${this.$t("_.staff")} –`, ...arr].join(" ")]
          )
      };
    if (this.data.access_role === AccessRoleTypes.CLIENT)
      return {
        render: (h: CreateElement) =>
          h(
            "u-link",
            {
              props: {
                tag: "router-link"
              },
              attrs: {
                to: {
                  name: "adminClient",
                  params: { clientId: this.data.access_user_id }
                }
              }
            },
            [[`${this.$t("_.client")} –`, ...arr].join(" ")]
          )
      };
    return arr.join(" ");
  }

  public get hookLog() {
    return this.$_.omit(this.data, ["_order"]);
  }

  public get objectUI() {
    if (this.data.object_type === "contracts_product") {
      return {
        component: {
          name: "TimelineLogCProd",
          render: (h: CreateElement) => {
            const props = {
              contractId: this.data.object?.contract_id
            };
            if (
              ProductCategoryTypes.PRODUCT_OPTION ===
              this.data.object?.product?.category?.category_type
            )
              props["productOptionId"] = this.data.object_id;
            else if (
              ProductCategoryTypes.PRODUCT_ATTRIBUTE ===
              this.data.object?.product?.category?.category_type
            )
              props["productAttributeId"] = this.data.object_id;
            else props["productId"] = this.data.object_id;

            return h(CProdProvider, {
              props: {
                ...props,
                onNotFound: () => {
                  // Do nothing, no redirecting
                }
              },
              scopedSlots: {
                default: ({ $cProdData }) => {
                  return h(CProdWellLink, {
                    props: {
                      cProd: $cProdData.contractProduct,
                      clientId: $cProdData?.contract?.client_id
                    }
                  });
                }
              }
            });
          }
        }
      };
    } else if (this.data.object_type === "user") {
      return {
        component: {
          name: "TimelineLogUser",
          render: (h: CreateElement) =>
            h(UserProvider, { props: { userId: this.data.object_id } }, [
              h(UserWell)
            ])
        }
      };
    } else if (this.data.object_type === "client") {
      return {
        component: {
          name: "TimelineLogClient",
          render: (h: CreateElement) =>
            h(ClientProvider, {
              props: { clientId: this.data.object_id },
              scopedSlots: {
                default: (props: { $clientData: IClientProviderData }) => {
                  const { $clientData } = props;
                  return h(ClientWellLink, {
                    props: {
                      client: $clientData.client
                    },
                    nativeOn: {
                      click: () => this.$emit("close")
                    }
                  });
                }
              }
            })
        }
      };
    }

    return null;
  }
}
